import { Pipe, PipeTransform } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DetectionService } from '../../services/detection.service';

@Pipe({ name: 'confidenceColor' })
export class ConfidenceColorPipe implements PipeTransform {
  constructor(private detectionService: DetectionService) {}

  transform(confidence: number): Observable<string> {
    return this.detectionService.getDetectionThresholds().pipe(
      map(thresholds => {
        let i = 0;
        while (thresholds.length > i && confidence > thresholds[i].threshold) {
          i += 1;
        }
        const threshold = thresholds[i - 1];
        if (threshold && threshold.color) {
          return threshold.color;
        } else {
          return '#fff'; // Default value
        }
      })
    );
  }
}
